import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
  getUserType,
} from '../redux/selectors/ResditBySendingAirlineSelectors';
import ReportDefinitions from '../../../../common/config/ReportDefinitions';
import ResditBySendingAirlineReport from '../component/ResditBySendingAirlineReport';

export function ResditBySendingAirlineContainer(props) {
  return (
    <ResditBySendingAirlineReport
      reportId={ReportDefinitions.RESDIT_BY_SENDING_AIRLINE.id}
      generatedOnDateTime={props.generatedDateTime}
      isLoading={props.isLoading}
      data={props.data}
      columns={props.columns}
      userType={props.userType}
      className="carditBySendingPostReport"
    />
  );
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    columns: getColumns(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    userType: getUserType(state),
  };
}

ResditBySendingAirlineContainer.propTypes = {
  generatedDateTime: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  isLoading: PropTypes.bool,
  userType: PropTypes.string,
};

export default connect(mapStateToProps)(ResditBySendingAirlineContainer);
